export const PROJECT_DOWNLOAD_RESET = 'PROJECT_DOWNLOAD_RESET'
export const PROJECT_DOWNLOAD_ERROR = 'PROJECT_DOWNLOAD_ERROR'
export const PROJECT_DOWNLOAD_VIOLATIONS = 'PROJECT_DOWNLOAD_VIOLATIONS'
export const PROJECT_DOWNLOAD_LOADING_TOGGLE = 'PROJECT_DOWNLOAD_LOADING_TOGGLE'

export const PROJECT_DOWNLOAD_CREATED = 'PROJECT_DOWNLOAD_CREATED'
export const PROJECT_DOWNLOAD_ALL = 'PROJECT_DOWNLOAD_ALL'
export const PROJECT_DOWNLOAD_SINGLE = 'PROJECT_DOWNLOAD_SINGLE'
